import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"display":"flex","justify-content":"center","margin-bottom":"2.25rem"}
}
const _hoisted_2 = { class: "d-flex align-items-center mt-5 py-3 mt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_4 = { class: "text-muted fs-6 fw-bold ms-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.MedicalRecordsTableLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("Loading")) + "...", 1)
        ])
      ]))
    : _createCommentVNode("", true)
}